import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";

export default function AppDrawer(props) {
    const { open, onClose } = props;
    const history = useHistory();
    const informationState = useSelector((state) => state.Information);

    const LinkClick = (link) => {
        history.push(link);
    };
    const links = [
        { label: "Top", link: "/", icon: <InboxIcon />, disabled: true },
        { label: "お申込み履歴", link: "/PartyList", icon: <MailIcon />, disabled: informationState["organizer"]["user_login"] },
        { label: "会員情報", link: "/UserInfo", icon: <InboxIcon />, disabled: informationState["organizer"]["user_login"] },
    ];

    const list = (anchor) => (
        <Box
            // sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
            role="presentation"
            onClick={onClose}
            onKeyDown={onClose}
        >
            <List>
                {links.map((link_data, index) => (
                    <ListItem key={index} disablePadding style={{ display: link_data.disabled ? '' : 'none' }}>
                        <ListItemButton onClick={() => LinkClick(link_data.link)}>
                            <ListItemIcon>{link_data.icon}</ListItemIcon>
                            <ListItemText primary={link_data.label} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            <Divider />
        </Box>
    );

    return (
        <div>
            <Drawer anchor={"left"} open={open} onClose={onClose}>
                {list("left")}
            </Drawer>
        </div>
    );
}
